module.exports = __webpack_public_path__ + "static/media/logo.7365a75a.jpg";